import { PauseOctagonIcon } from './PauseOctagonIcon';

/**
 * author: Austin Andrews
 * id D0A95719-9B9F-4E86-A6E5-8013C1A6D4A7
 * name pause-octagon
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pause-octagon.svg
 * tags
 */
export const StopPauseIcon = PauseOctagonIcon;
export default StopPauseIcon